class Configuration {
  public BaseUrl: string;
  constructor() {
    if (process.env.REACT_APP_API_URL !== undefined) {
      this.BaseUrl = process.env.REACT_APP_API_URL;
    } else if (process.env.NODE_ENV === 'development') {
      this.BaseUrl = 'http://localhost:5002';
    } else {
      this.BaseUrl = '/api';
    }
  }
}

export default Configuration;
